import app from 'app';
import RCP from '@wochitnpm/rcp';
import Marionette from 'backbone.marionette';
import RcpControlPanel from 'v/assetModal/RcpControlPanel.vue';

app.namespace.Controller.FullPreviewPlayerController = Marionette.Object.extend(
  {
    eventNamespace: '.fullPreviewPlayer',

    onBeforeDestroy: function () {
      $(document).off(this.eventNamespace);
      this.rcpPanel && this.rcpPanel.$destroy();
      this.rcp && this.rcp.destroy();
      this.rcpPanel = null;
      this.rcp = null;
    },

    initialize: function (options) {
      options = Object.assign(
        {
          story: null,
          rcpWidth: 800,
          rcpHeight: 450,
          rcpRef: null,
          rcpPanelRef: null,
          onTogglePlay: _.noop,
        },
        options || {}
      );

      this.story = options.story;

      this.state = new Backbone.Model({
        /** FINAL' || 'PARTIAL'*/
        mode: null,
        /** parts currently present in rcp */
        parts: [],
      });

      this.rcp = new RCP({
        showDiagnostic: false,
        el: options.rcpRef,
        width: options.rcpWidth,
        height: options.rcpHeight,
        innerAspectRatio: app.ASPECT_RATIOS[app.currentAspectRatio].ratio,
      });

      this.rcp.on(RCP.MSG.VOLUMECHANGE, this.reflectVolumeChange.bind(this));
      this.rcp.on(RCP.MSG.PLAY, () => options.onTogglePlay(true));
      this.rcp.on(RCP.MSG.PAUSE, () => options.onTogglePlay(false));

      this.rcpPanel = new RcpControlPanel({
        el: options.rcpPanelRef,
        rcp: this.rcp,
      });
    },

    togglePlay: function () {
      this.rcp.togglePlay();
    },

    play: function () {
      this.rcp.play();
    },

    pause: function () {
      this.rcp.pause();
    },

    takeScreenshot: function () {
      return this.rcp.takeScreenshot();
    },

    /**
     * @param inclination {Number} -1 or +1
     */
    seek: function (inclination) {
      const ct = this.rcp.getCurrentTime();
      const seekDuration = this.rcp.isPlaying() ? 5 : 0.1 / 3;
      const seekOffset = seekDuration * inclination;
      this.rcp.seek(ct + seekOffset);
    },

    _addVideo: function (src, duration, play) {
      this.rcp.append({
        play: play,
        item: {
          type: 'video',
          volume: 1,
          src: app.prependHttp(src),
          play: { duration: duration },
        },
      });
    },

    setVideoUrl: function (jobCarrier, play = true) {
      this.state.set('mode', 'FINAL');
      this.rcp.reset();

      const videoDuration = jobCarrier.get('videoDuration');
      this._addVideo(jobCarrier.get('cdnUrl'), videoDuration, play);

      this.rcpPanel.time.total = videoDuration;
      this.rcpPanel.time.buffered = this.rcpPanel.time.total;
    },

    marshalPreviewParts: function (jobCarrier) {
      this.state.set('mode', 'PARTIAL');

      const state = {
        jobParts: jobCarrier.get('parts'),
        parts: [],
        isFirst: false,
        hasLast: false,
        newParts: [],
        autoplay: false,
      };

      // normalize order of the `state.jobParts`
      // i.e: allow following state.parts := [undefined, {}, undefined, {}]
      _.each(
        state.jobParts,
        function (part, key) {
          /*
       (key) 'AUDIO': {
       data: {cdnUrl},
       message: 'DONE'             // or NA
       }
       */
          if ('AUDIO' === key) {
            if (!this._audioPart) {
              this._audioPart = {
                available: part.message === 'DONE',
                cdnUrl: part.data && part.data.cdnUrl,
              };
              if (this._audioPart.available) {
                this.rcp.append({
                  play: true,
                  item: {
                    type: 'bgMusic',
                    src: app.prependHttp(this._audioPart.cdnUrl),
                    volume: 1,
                  },
                });
                if (!this.rcp.playList.hasNoVisualContent()) {
                  this.rcp.play();
                }
              }
              // console.info(`FPPC::AUDIO @`, jobCarrier.time.passed().toFixed(1), 'sec');
            }
            return true; // continue;
          }

          /* single part
       (key) 0002: (part) {
       data: {cdnUrl, duration}   // actual data
       message:"DONE"             // or COMPLETED
       timestamp:1481817902       // unix timestamp
       }
       */
          const iPartNumber = parseInt(key, 10);
          if ('0000' === key && _.isEmpty(this.state.get('parts'))) {
            state.isFirst = true;
          }
          part.data.number = iPartNumber;
          if ('COMPLETED' === part.message) {
            state.hasLast = true;
            part.data.isLast = true;
          }
          state.parts[iPartNumber] = part.data;
        }.bind(this)
      );

      // add only if this.state.get('parts').length exists in state.parts
      for (
        let i = this.state.get('parts').length, I = state.parts.length;
        i < I;
        i++
      ) {
        if (state.parts[i]) {
          state.newParts.push(state.parts[i]);
        } else {
          break;
        }
      }

      if (state.newParts.length) {
        state.autoplay = !!this._audioPart;
        _.each(
          state.newParts,
          function (part) {
            // console.info(`FPPC::Part #${part.number}`,
            //     part.isLast ? 'last' :
            //         (0 === part.number ?
            //             `@ ${jobCarrier.time.passed().toFixed(1)} sec` :
            //             ''));

            if (part.isLast && part.duration < 0.1) {
              console.info('FPPC::Last part ignored');
            } else {
              this.rcp.append({
                play: state.autoplay,
                item: {
                  type: 'video',
                  src: app.prependHttp(part.cdnUrl),
                  blob: true,
                  play: { duration: part.duration },
                  volume: 0.0,
                  origin: `Part #${part.number}`,
                },
              });
            }
            this.state.get('parts').push(part);
          }.bind(this)
        );
      }

      this.rcpPanel.time.buffered = _.sumBy(this.state.get('parts'), (part) => {
        return part.duration;
      });

      if (state.isFirst) {
        this.rcpPanel.time.total = jobCarrier.get('videoDuration');
        app.doctorController.reportFullPreviewStreaming(
          jobCarrier.time.passed()
        );
      } else if (state.hasLast) {
        this.rcpPanel.time.total = this.rcp.playList.feed.totalDisplayTime;
      }
    },

    reflectVolumeChange: function (volume) {
      if (
        this.rcp.playList.hasNoVisualContent() ||
        _.isEmpty(this.rcp.playList.feed.bgMusic)
      ) {
        return;
      }

      const tItem = this.rcp.playList.feed.bgMusic[0];
      const mItem = tItem && tItem.getMediaItem();
      if (mItem) {
        mItem.el.volume = volume;
      }
    },
  }
);

export default app.namespace.Controller.FullPreviewPlayerController;
